exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Azj8Hur0NClzjbMesE3nf{max-width:500px!important;width:430px!important}", ""]);
// Exports
exports.locals = {
	"errorModal": "_2Azj8Hur0NClzjbMesE3nf"
};